const exceptionalRefStoryBuilder=(formValues)=>

{
let story = "\n\n" 
if (formValues.Reason_for_Referral=== "Strong clinical suspicion")
    {
    story += `I have high level of concern about the possibility of cancer`
    }
    if (formValues.Reason_for_concern_if_not_already_outlined_in_clinical_history !== "")
        {
        story += ` because ${formValues.Reason_for_concern_if_not_already_outlined_in_clinical_history}`
        }
    else 
        {
        story += "The patient had"

        if(formValues.Reason_for_Referral==="Histological proof of cancer")
            {
            story += " a histological analysis"
            }

        else
            { 
            let test
            let testType
            if (formValues.Reason_for_Referral === "Suspicion of cancer on imaging or endoscopy")
                {
                test =  formValues.Type_of_imaging
                testType = " examination"
                }
            else 
                {
                test = formValues.Type_of_Lab_test
                testType = " test"
                }
            let pronoun = (["a","e","i","o","u"].includes((test.charAt(0)).toLowerCase()) ? "an" : "a")
            story += ` ${pronoun} ${test} ${testType}`
            } 
    if (formValues.Hospital_where_investigation_performed !== "")
        {
        story += ` at ${formValues.Hospital_where_investigation_performed}`
        }

    
    if (formValues.Date_of_test_or_investigation !== "")
    {
    let testDate = new Date (formValues.Date_of_test_or_investigation)
    let testDateString = testDate.toLocaleDateString()
    story += ` on ${testDateString}`
    }

    if (formValues.Result_of_imaging_or_endoscopy !=="")
        {
        story += ` which showed ${formValues.Result_of_imaging_or_endoscopy}`
        }

    else if (formValues.Result_of_lab_test_or_histology !== "")
        {
        story += ` which showed ${formValues.Result_of_lab_test_or_histology}`
        }  
    else
        {
        story += " which showed a strong suspicion of cancer"
        }
    
}
story += ".\n\n"
return story
}


export default exceptionalRefStoryBuilder